import { SeasonalRuleDetail } from 'models/seasonality/SeasonalRule';
import API from 'services/API';

export const fetchSeasonalRuleDetail = async (
  seasonalRuleUid: string,
): Promise<SeasonalRuleDetail> => {
  const response = await API.get<SeasonalRuleDetail>(
    `api/internal/seasonal-rules/cancellation-policies/${seasonalRuleUid}`,
  );
  return response.data;
};
